import React from 'react';
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button } from "reactstrap";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PurchaseManagerApprovalRequisition from './ApprovalRequisition';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import ApprovalRequisitionHistory from '../PurchaseManager/ApprovalRequisitionHistory';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const PurchasemanagerRequisitionTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const top100Films = [
    { label: 'The Shawshank Redemption', year: 1994 },
    { label: 'The Godfather', year: 1972 },
    { label: 'The Godfather: Part II', year: 1974 },
    { label: 'The Dark Knight', year: 2008 },
    { label: '12 Angry Men', year: 1957 },]

  return (
    <div className="page-content">
    <Container fluid>
    <Box sx={{ width: '100%' }}>
      <Box sx={{backgroundColor:"white" }}>
        {/* <Tabs value={value} onChange={handleChange}>
          <Tab label="View and Edit"  {...a11yProps(0)} />
          <Tab label="Approval Pending"  {...a11yProps(1)} />
        </Tabs> */}
      </Box>
      <CustomTabPanel className="tabs_padding" value={value} index={0}>
        <PurchaseManagerApprovalRequisition setTab={setValue} />
      </CustomTabPanel>
      {/* <CustomTabPanel className="tabs_padding" value={value} index={1}>
        <ApprovalRequisitionHistory />
      </CustomTabPanel> */}
    </Box>
    </Container>
    </div>
  );
}
export default PurchasemanagerRequisitionTabs;